import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface TerminInfoRowProps extends React.HTMLAttributes<HTMLDivElement> {
  icon: IconDefinition;
  children: React.ReactNode;
}

export function TerminInfoRow({
  icon,
  children,
  className,
  ...divProps
}: TerminInfoRowProps) {
  return (
    <div
      className={`flex items-start text-sm gap-3 break-words text-wrap overflow-hidden ${
        className ?? ''
      }`}
      {...divProps}>
      <FontAwesomeIcon icon={icon} className="mt-1" />
      <div className="flex-1 min-w-0">{children}</div>
    </div>
  );
}
